export default __webpack_public_path__ + "static/media/people.985b1958.svg";